/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Conversation conclusion
 * @export
 * @interface BridgeApiConversationConclusion
 */
export interface BridgeApiConversationConclusion {
    /**
     * 
     * @type {string}
     * @memberof BridgeApiConversationConclusion
     */
    id: string;
    /**
     * Id of conversation template
     * @type {string}
     * @memberof BridgeApiConversationConclusion
     */
    templateId: string;
    /**
     * Id of a conversation where the conclusion belongs to
     * @type {string}
     * @memberof BridgeApiConversationConclusion
     */
    conversationId: string;
    /**
     * JSON conclusion content
     * @type {string}
     * @memberof BridgeApiConversationConclusion
     */
    content: string;
}

/**
 * Check if a given object implements the BridgeApiConversationConclusion interface.
 */
export function instanceOfBridgeApiConversationConclusion(value: object): value is BridgeApiConversationConclusion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('templateId' in value) || value['templateId'] === undefined) return false;
    if (!('conversationId' in value) || value['conversationId'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function BridgeApiConversationConclusionFromJSON(json: any): BridgeApiConversationConclusion {
    return BridgeApiConversationConclusionFromJSONTyped(json, false);
}

export function BridgeApiConversationConclusionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BridgeApiConversationConclusion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'templateId': json['templateId'],
        'conversationId': json['conversationId'],
        'content': json['content'],
    };
}

export function BridgeApiConversationConclusionToJSON(json: any): BridgeApiConversationConclusion {
    return BridgeApiConversationConclusionToJSONTyped(json, false);
}

export function BridgeApiConversationConclusionToJSONTyped(value?: BridgeApiConversationConclusion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'templateId': value['templateId'],
        'conversationId': value['conversationId'],
        'content': value['content'],
    };
}

